export default (str) => window.btoa(unescape(encodeURIComponent(str)))
